const initUpButton = () => {
  const upButton = document.querySelector('.up-btn__link');

  if (!upButton) {
    return;
  }

  document.addEventListener('scroll', () => {
    if (window.scrollY > window.innerHeight) {
      upButton.classList.add('is-active');
    } else {
      upButton.classList.remove('is-active');
    }
  });
};

export {initUpButton};
